<template>
    <a-card :bordered="false">
      <a-form-item><a @click="routeBack">&lt;&lt; 返回</a></a-form-item>
      <detail-list title="装卸料口详情" v-if="mdl">
        <detail-list-item term="所属装卸货点">{{ mdl.factoryLoadName }}</detail-list-item>
        <detail-list-item term="装卸料口ID">{{ mdl.materialLoadId }}</detail-list-item>
        <detail-list-item term="料口编号">{{ mdl.code }}</detail-list-item>
        <detail-list-item term="终端编号">{{ mdl.terminalCode }}</detail-list-item>
        <detail-list-item term="控制器IP">{{ mdl.ctrlIp }}</detail-list-item>
        <detail-list-item term="控制器服务端端口号">{{ mdl.serverPort }}</detail-list-item>
        <detail-list-item term="门禁读卡器IP">{{mdl.doorCardIp}}</detail-list-item>
        <detail-list-item term="门禁读卡器端口号">{{ mdl.doorCardPort }}</detail-list-item>
        <detail-list-item term="大屏幕地址">{{ mdl.screenAddress }}</detail-list-item>
        <detail-list-item term="计数器通讯地址">{{mdl.counterAddress}}</detail-list-item>
        <detail-list-item term="计数器设备地址ID">{{ mdl.counterDeviceAddress }}</detail-list-item>
        <detail-list-item term="计数器波特率">{{ mdl.counterBaudRate }}</detail-list-item>
        <detail-list-item term="计数器数据位">{{ mdl.counterDataBit }}</detail-list-item>
        <detail-list-item term="计数器校验位">{{ mdl.counterParityBit }}</detail-list-item>
        <detail-list-item term="计数器停止位">{{ mdl.counterStopBit }}</detail-list-item>
        <detail-list-item term="喷码机通讯地址">{{mdl.printerAddress}}</detail-list-item>
        <detail-list-item term="喷码机设备地址ID">{{ mdl.printerDeviceAddress }}</detail-list-item>
        <detail-list-item term="喷码机波特率">{{ mdl.printerBaudRate }}</detail-list-item>
        <detail-list-item term="喷码机数据位">{{ mdl.printerDataBit }}</detail-list-item>
        <detail-list-item term="喷码机校验位">{{ mdl.printerParityBit }}</detail-list-item>
        <detail-list-item term="喷码机停止位">{{ mdl.printerStopBit }}</detail-list-item>
        <detail-list-item term="熟料皮带秤通讯地址">{{ mdl.beltScaleAddress }}</detail-list-item>
        <detail-list-item term="货物包装类型">{{ mdl.materielTypeName }}</detail-list-item>
        <detail-list-item term="DCS服务名">{{ mdl.dcsServerName }}</detail-list-item>
        <detail-list-item term="DCS标签">{{ mdl.dcsTag }}</detail-list-item>
        <detail-list-item term="启用状态">{{ mdl.usedName }}</detail-list-item>
        <detail-list-item term="运输工具类型">{{ mdl.transportTypeName }}</detail-list-item>
      </detail-list>
    </a-card>
  </page-view>
</template>

<script>
import DetailList from '@/components/tools/DetailList'
import Moment from 'moment'
import storage from "@/utils/storage"


const DetailListItem = DetailList.Item

export default {
  components: {
    DetailList,
    DetailListItem
  },
  data () {
    return {
      mdl: null
    }
  },
  mounted () {
    this.initData()
  },
  filters: {
    formatDate (value) {
      return Moment(value).format('YYYY-MM-DD HH:mm:ss')
    }
  },
  methods: {
    routeBack(){
      localStorage.setItem('goback', "true");
      this.$router.back(-1)
    },
    initData () {
      let cache = storage.fetch("cache-FactoryLoadPortDetail");
        if (cache){
            this.mdl = JSON.parse(cache);
        } 
    }
  }
}
</script>



